import { createContext, ReactNode, useCallback, useContext } from "react";

type ScrollContextValue = {
    scrollToSection: (id: string) => void;
};

const ScrollContext = createContext<ScrollContextValue>({
    scrollToSection: () => undefined,
});

type ScrollProviderProps = {
    children: ReactNode;
    scrollToSection?: (id: string) => void;
};

const ScrollProvider = ({ children, scrollToSection }: ScrollProviderProps) => {
    const handleScrollToSection = useCallback(
        (id: string) => {
            if (!id) return;
            if (scrollToSection) {
                scrollToSection(id);
                return;
            }

            const element = document.getElementById(id);
            element?.scrollIntoView({ behavior: "smooth", block: "start" });
        },
        [scrollToSection]
    );

    return (
        <ScrollContext.Provider value={{ scrollToSection: handleScrollToSection }}>
            {children}
        </ScrollContext.Provider>
    );
};

const useScrollToSection = () => useContext(ScrollContext);

export { ScrollProvider, useScrollToSection };
